import React from 'react';
import { Lock } from 'lucide-react';
import { useSetActivity } from '@/common/hooks/useSetActivity';
import { BlockingContent } from 'course-types';

interface LockedContentProps {
  blockingContent: BlockingContent;
  courseId?: string;
  courseName?: string;
}

export default function LockedContent({
  blockingContent,
  courseId,
  courseName,
}: LockedContentProps) {
  const setActivity = useSetActivity({
    courseId,
    courseName,
  });

  const handleClick = () => {
    if (blockingContent.id) {
      setActivity({
        id: blockingContent.id,
        name: blockingContent.name,
        type: blockingContent.type as 'document' | 'video' | 'quiz' | 'resource' | 'assignment',
        description: blockingContent.description,
        subunit_id: blockingContent.subunit_id,
        unit_id: blockingContent.unit_id,
      });
    }
  };

  return (
    <div className='w-full h-full flex items-center justify-center'>
      <div
        className='flex flex-col items-center justify-center text-center cursor-pointer p-4 rounded-lg'
        onClick={handleClick}
      >
        <Lock size={32} className='text-gray-700 mb-2' />
        <span className='text-lg font-medium text-gray-700 mb-2 hover:underline'>
          Complete {blockingContent.name}{' '}
          {blockingContent.requires_minimum_grade
            ? `with a grade of ${blockingContent.minimum_grade_threshold} or higher`
            : ''}{' '}
          to unlock.
        </span>
      </div>
    </div>
  );
}
